import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useScroll } from '../../../../context/scroll-context';



const ServicesSection = ({ image, alt }) => {

    const { scrollToSection, contactform } = useScroll();

    const handleScrollAndClose = (refName) => {
        scrollToSection(refName);
    };

    return (
        <section className="bg-primary">
            <Container fluid className="p-4 p-lg-5 text-center">
                <h2 className="text-white text-center text-uppercase mb-5 ft-wt-600">What Can We Do For You?</h2>
                <Row className="justify-content-center">
                    <Col xs="12">
                        <div className="text-center mb-5">
                            <img src={image} alt={alt} className="img-fluid" loading="lazy" />
                        </div>
                        <div className="p-2">
                            <Button variant="secondary" className="text-uppercase" onClick={() => handleScrollAndClose(contactform)}>Apply for a free 2 weeks trial</Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ServicesSection;
